'use strict';

angular.module('app.rankingScoreReportExposure', [])
    .directive('rankingScoreReportExposureDirective', function () {
        return {
            controller: 'rankingScoreReportExposureCtrl',
            templateUrl: 'app/measure/rankingScoreReport/rankingScoreReportExposure/rankingScoreReportExposure.html?app_v=deployDate',
            restrict: 'E',
            scope: {
                
            },
            replace: true,
            transclude: true
        };
    })